import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import RequireGroup from "../../routes/RequireGroup";
import JobBottleneckPage from "./pages/JobBottleneck";
import MaterialMovementsPage from "./pages/MaterialMovements";
import PendingCutsPage from "./pages/PendingCuts";
import ShopPerformancePage from "./pages/ShopPerformance";
import ManageInventoryPage from "./pages/ManageInventoryPage";
import SettingsPage from "./pages/SettingsPage";

const AdminRoutes: React.FC = () => {
	return (
		<Routes>
			{/* Default redirect */}
			<Route path="/" element={<Navigate to="locations/manage" replace />} />

			{/* Compatibility redirect for old bookmarks */}
			<Route path="locations" element={<Navigate to="locations/manage" replace />} />

			{/* Manage inventory hierarchy — readable by any authenticated user;
			    write actions are gated by requireShopManager() inside the page. */}
			<Route path="locations/manage" element={<ManageInventoryPage />} />

			{/* Settings — restricted to Shop Managers */}
			<Route path="settings" element={<RequireGroup group="Shop Managers"><SettingsPage /></RequireGroup>} />

			{/* Reports — restricted to Shop Managers, matching the API behind them.
			    Admin ▸ Reports is a submenu with no page of its own, so a typed or
			    bookmarked /admin/reports lands on a report instead of the 404 below.
			    Absolute target: a relative one would resolve against /admin/reports. */}
			<Route path="reports" element={<Navigate to="/admin/reports/job-bottleneck" replace />} />
			<Route path="reports/job-bottleneck" element={<RequireGroup group="Shop Managers"><JobBottleneckPage /></RequireGroup>} />
			<Route path="reports/shop-performance" element={<RequireGroup group="Shop Managers"><ShopPerformancePage /></RequireGroup>} />
			{/* Open to every signed-in user (floor leads run the daily spot check);
			    only the menu entry sits behind the Shop Managers Admin menu. */}
			<Route path="reports/material-movements" element={<MaterialMovementsPage />} />
			<Route
				path="reports/pending-cuts"
				element={
					<RequireGroup group="Shop Managers">
						<PendingCutsPage />
					</RequireGroup>
				}
			/>

			{/* 404 inside admin */}
			<Route path="*" element={<div>Admin Page Not Found</div>} />
		</Routes>
	);
};

export default AdminRoutes;
